export const environment = {
  production: true,
  apiUrl: 'https://api-ventaclick-dev.megatecs.org',
  apiMicaChatUrl: 'https://api-mica-chat-dev.megatecs.org',
  apiMicaChatEvolutionUrl: 'https://api-mica-chat-evo-dev.megatecs.org',
  apiFacturacionUrl: 'https://api-facturacion-dev.megatecs.org',
  apiReservasUrl: 'https://api-reservas-dev.megatecs.org',
  apiPreFix: '/api',
  asyncServices: true,
  name: 'development',
  pideloPublicUrl: 'https://pidelo-dev.megatecs.org',
  qzTrayEnabled: true,
  strongPasswordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
  locale: 'es-PE',
  igvOptions: [0.18, 0.105],
  festiveTheme: null,
};
// festive:
// null
// - fiestas-patrias
